import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { nodata } from "../../Routes/ImagePath";

// Helper function to format the date
const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

const AttendenceModelPopup = ({ selectedEmployee, selectedDay, dayStatus, onAttendanceSaved }) => {
  const [attendanceData, setAttendanceData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);
  const [editedData, setEditedData] = useState({
    punchIn: "",
    punchOut: "",
    remarks: "",
  });

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  // Fetch or reset attendance data based on dayStatus
  // Fetch or reset attendance data based on dayStatus
useEffect(() => {
  if (selectedEmployee && selectedDay) {
    if (dayStatus === "normal") {
      setLoading(true);
      axios
        .get(`${apiUrl}/attendance/attendance-bydate`, {
          params: {
            empid: selectedEmployee.empid,
            date: selectedDay,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const data = response.data;

          // Set activity log from response
          setActivities(data.activity_log || []);

          // Use the hours_worked value directly from the response
          const hoursWorkedFormatted = data.hours_worked;

          // Use check_in_time and check_out_time directly from the response
          const punchInFormatted = data.check_in_time || "-";
          const punchOutFormatted = data.check_out_time || "-";

          setAttendanceData({
            date: selectedDay,
            punchIn: punchInFormatted,
            punchOut: punchOutFormatted,
            hoursWorked: hoursWorkedFormatted,
            breakTime: hoursWorkedFormatted, // Adjust as needed
            overtime: "0 hrs", // Set this to a calculated value if needed
          });

          setEditedData({
            punchIn: data.check_in_time,
            punchOut: data.check_out_time,
            remarks: "",
          });

          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching attendance data:", error);
          setLoading(false);
        });
    } else if (dayStatus === "normalnodata") {
      setAttendanceData(null);
      setEditMode(false);
      setActivities([]);
      setEditedData({
        punchIn: "",
        punchOut: "",
        remarks: "",
      });
      setLoading(false);
    }
  }
}, [selectedEmployee, selectedDay, dayStatus, apiUrl, token]);


  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleSaveClick = () => {
    if (!editedData.punchIn) {
      alert("Please enter the punch-in time.");
      return;
    }
  
    if (editedData.punchOut && editedData.punchOut <= editedData.punchIn) {
      alert("Punch out time must be later than punch in time.");
      return;
    }
  
    const payload = {
      emp_id: selectedEmployee.empid,
      attendance_date: selectedDay,
      attendance_type: "in_out",
      check_in_time: editedData.punchIn,
      check_out_time: editedData.punchOut || null,
      location: "Office",
      coordinates: "28.6139,77.2090",
      notes: editedData.remarks,
      ip: "192.168.1.1",
      marked_manually: true,
    };
  
    axios
      .post(`${apiUrl}/attendance/add`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        //setEditMode(false);
  
        const punchIn = new Date(`${selectedDay}T${editedData.punchIn}`);
        let hoursWorkedFormatted = "N/A";
        let punchOutFormatted = editedData.punchOut || "Not Checked Out";
  
        if (editedData.punchOut) {
          const punchOut = new Date(`${selectedDay}T${editedData.punchOut}`);
          const hoursWorkedMs = punchOut - punchIn;
          const hours = Math.floor(hoursWorkedMs / (1000 * 60 * 60));
          const minutes = Math.floor((hoursWorkedMs % (1000 * 60 * 60)) / (1000 * 60));
          hoursWorkedFormatted = `${hours} hrs ${minutes} mins`;
  
          punchOutFormatted = punchOut.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        }
  
        toast.success("Attendance saved successfully!");
  
        const updatedDayData = {
          empid: selectedEmployee.empid,
          date: selectedDay,
          newStatus: editedData.punchIn ? "P" : "-",
        };
  
        if (typeof onAttendanceSaved === "function") {
          onAttendanceSaved(updatedDayData);
        }
  
        // Update the attendanceData state with the newly added or edited data
        setAttendanceData({
          date: selectedDay,
          punchIn: editedData.punchIn,
          punchOut: punchOutFormatted,
          hoursWorked: hoursWorkedFormatted,
          breakTime: "N/A",
          overtime: "N/A",
        });

        // Update the activities state
        const updatedActivities = [...activities];
        updatedActivities.unshift({
          type: "in",
          time: editedData.punchIn,
          location: "Office",
          notes: editedData.remarks || "Manual entry",
        });
        if (editedData.punchOut) {
          updatedActivities.unshift({
            type: "out",
            time: punchOutFormatted,
            location: "Office",
            notes: editedData.remarks || "Manual entry",
          });
        }
        setActivities(updatedActivities);

      })
      .catch((error) => {
        console.error("Error saving attendance:", error);
      });
  };

  const handleCancelClick = () => {
    setEditMode(false);
    setEditedData(
      attendanceData
        ? {
            punchIn: attendanceData.punchIn,
            punchOut: attendanceData.punchOut,
            remarks: "",
          }
        : { punchIn: "", punchOut: "", remarks: "" }
    );
  };

  const handleTimeChange = (e, field) => {
    setEditedData({ ...editedData, [field]: e.target.value });
  };

  const handleRemarksChange = (e) => {
    setEditedData({ ...editedData, remarks: e.target.value });
  };

  // Helper function to format the date
const formatDate = (dateString) => {
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-US', options);
};


  const renderContent = () => {
    if (loading) {
      return (
        <div id="loader-wrapper_">
          <div className="loader">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      );
    } else if (dayStatus === "leave") {
      return <p>Leave Applied - No attendance can be recorded.</p>;
    } else if (dayStatus === "weekend") {
      return <p>Weekend - No attendance required.</p>;
    } else if (dayStatus === "holiday") {
      return <p>Holiday - No attendance required.</p>;
    } else if (dayStatus === "normalnodata" && !editMode) {
      return (


        <div className="no-data-container">
        <img 
          src="https://netshine-assets.blr1.cdn.digitaloceanspaces.com/app-assets/empty-data.svg" 
          alt="No data available" 
        />
        
        
        <p>
        System didn't find any attendance for the{" "}
        <strong>{attendanceData?.date || selectedDay}</strong> .
       
          </p>
          <button className="btn btn-primary" onClick={handleEditClick}>
            Add Attendance
          </button>
        </div>
         
      );
    } else if (attendanceData && !editMode) {
      return (
        <>
          <div className="col-md-6">
            <div className="card punch-status">
              <div className="card-body">
                <h5 className="card-title">
                  Attendance Overview
                  <a
                    className="edit-icon float-end"
                    onClick={handleEditClick}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-pencil"></i>
                  </a>
                </h5>

                <span className="text-muted">
                  {formatDate(attendanceData.date)}
                </span>
                <br />
                <span>{selectedEmployee.name}</span>
                <div className="punch-det">
                  <h6>Punch In at</h6>
                  <p>{attendanceData.punchIn}</p>
                </div>
                <div className="punch-info">
                  <div className="punch-hours">
                    <span>{attendanceData.hoursWorked}</span>
                  </div>
                </div>
                <div className="punch-det">
                  <h6>Punch Out at</h6>
                  <p>{attendanceData.punchOut}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card recent-activity">
              <div className="card-body">
                <h5 className="card-title">Activity</h5>
                <ul className="res-activity-list">
                  {activities.length > 0 ? (
                    activities.map((activity, index) => (
                      <li key={index}>
                        <p className="mb-0">
                          {activity.type.toUpperCase()} at {activity.location}
                        </p>
                        <p className="res-activity-time">
                          <i className="fa fa-clock-o" /> {activity.time} - {activity.notes}
                        </p>
                      </li>
                    ))
                  ) : (
                    <li>No activities yet.</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </>
      );
    } else if (editMode) {
      return (
        <>
          <div className="col-md-6">
            <div className="card punch-status">
              <div className="card-body">
                <h5 className="card-title">
                  {attendanceData ? "Edit Attendance" : "Add Attendance"}
                </h5>
                <div className="form-group">
                  <label>Punch In</label>
                  <input
                    type="time"
                    className="form-control"
                    value={editedData.punchIn}
                    onChange={(e) => handleTimeChange(e, "punchIn")}
                  />
                </div>
                <div className="form-group">
                  <label>Punch Out (Optional)</label>
                  <input
                    type="time"
                    className="form-control"
                    value={editedData.punchOut}
                    onChange={(e) => handleTimeChange(e, "punchOut")}
                  />
                </div>
                <div className="form-group">
                  <label>Remarks</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editedData.remarks}
                    onChange={handleRemarksChange}
                  />
                </div>
                <div className="form-group text-center mt-4">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleSaveClick}
                    style={{ width: "100px" }}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={handleCancelClick}
                    style={{ width: "100px" }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card recent-activity">
              <div className="card-body">
                <h5 className="card-title">Activity</h5>
                <ul className="res-activity-list">
                  {activities.length > 0 ? (
                    activities.map((activity, index) => (
                      <li key={index}>
                        <p className="mb-0">
                          {activity.type.toUpperCase()} at {activity.location}
                        </p>
                        <p className="res-activity-time">
                          <i className="fa fa-clock-o" /> {activity.time} - {activity.notes}
                        </p>
                      </li>
                    ))
                  ) : (
                    <li>No activities yet.</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <div className="col-md-12 text-center">
          <div className="no-data">
            <img src={nodata} alt="" />
            <p>
              System didn't find any attendance for the{" "}
              <strong>{attendanceData?.date || selectedDay}</strong> selected.
            </p>
            <button className="btn btn-primary mt-3" onClick={handleEditClick}>
              Add Attendance
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <div
      className="modal custom-modal fade"
      id="attendance_info"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div
          className="modal-dialog modal-lg"
          style={{
            margin: 0,
            position: "fixed",
            right: 0,
            height: "100vh",
            width: "50%",
          }}
          role="document"
        >
          <div className="modal-content h-100">
            <div className="modal-header">
              <h5 className="modal-title">Attendance Info</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
            >
              <div className="row">{renderContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendenceModelPopup;
